"use client";


export default function WhyChooseUs() {
  return (
    <section>
      <div className="container mx-auto px-5 md:px-8 lg:px-0 flex flex-col items-center gap-12">
        <div className="flex-1 flex flex-col items-center">
          <a
            href="/"
            className="text-3xl lg:text-4xl font-bold mt-12 mb-6 text-center font-extrabold uppercase tracking-wide bg-gradient-to-r from-teal-400 via-indigo-500 to-blue-600 bg-clip-text text-transparent drop-shadow-xl lg:text-[2.4rem] focus:outline-none"
            aria-label="Go to homepage"
          >
            <span className="lg:text-[3.05rem] shadow-lg px-3 py-1 rounded-lg">
              <span className="bg-gradient-to-r from-primary to-accent bg-clip-text text-transparent">
                Aether
              </span>
              <span className="text-blue-500">SIM</span>
            </span>
          </a>
          <div className="h-16" />
          <div className="flex flex-col items-center gap-5 mb-10 w-full">
            <a
              href="/contact"
              className="w-full max-w-xs inline-flex items-center justify-center px-5 py-2 rounded-md font-semibold bg-white text-green-600 shadow-lg transition-all duration-200 hover:bg-green-600 hover:text-white hover:scale-105 hover:shadow-xl focus:outline-none focus:ring-2 focus:ring-green-200"
            >
              Contact Us
            </a>
            <a
              href="/affiliate"
              className="w-full max-w-xs inline-flex items-center justify-center px-5 py-2 rounded-md font-semibold bg-white text-green-600 shadow-lg transition-all duration-200 hover:bg-green-600 hover:text-white hover:scale-105 hover:shadow-xl focus:outline-none focus:ring-2 focus:ring-green-200"
            >
              Become an affiliate partner
            </a>
          </div>
          <div className="mb-10 text-center max-w-2xl flex justify-center">
            <div className="relative flex items-center gap-6">
              <span
                className="lg:text-[1.35rem] font-extrabold text-green-400"
                style={{
                  letterSpacing: "0.03em",
                }}
              ></span>
              <span
                className="lg:text-[1.35rem] font-extrabold text-green-400"
                style={{
                  letterSpacing: "0.03em",
                }}
              ></span>
              <span
                className="lg:text-[1.35rem] font-extrabold text-green-400"
                style={{
                  letterSpacing: "0.03em",
                }}
              ></span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
